import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AdpApiService } from '../../../adp-api';

@Injectable({ providedIn: 'root' })
export class AdpAdminHttpClient {
  private readonly httpApi = inject(AdpApiService);

  public fetch(): Observable<Array<{}>> {
    return this.httpApi.get('workers').pipe(map(({ workers }: { workers: Array<[]> }) => workers));
  }
}
